<template>
  <google-map :center="center" :zoom="zoomValue" style="width: 100%; height: 500px">
    <google-marker
      v-for="(m, i) in markers"
      :position="m.position"
      :key="i"
      :clickable="true"
      :draggable="true"
      @click="center = m.position"
    ></google-marker>
  </google-map>
</template>

<script>
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_KEY,
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

export default {
  props: {
    lat: [Number],
    lng: [Number],
  },

  data() {
    return {};
  },

  computed: {
    zoomValue() {
      return this.zoom ? this.zoom : 20;
    },
    center() {
      return {
        lat: this.lat,
        lng: this.lng,
      };
    },
    markers() {
      return [
        {
          position: {
            lat: this.lat,
            lng: this.lng,
          },
        },
      ];
    },
  },
  components: {
    "google-map": VueGoogleMaps.Map,
    "google-marker": VueGoogleMaps.Marker,
  },
};
</script>